import { useCallback, useEffect } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import getLang from 'LearningCenterUI/utils/getLang';
import UsageTracker from '../../utils/UsageTracker';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { getAwardSharingPath } from '../../utils/RoutingUtils';
import { getMetadataLanguageFallback, SingleCertAchievement, useAchievementByTrackId } from '../../features/achievement';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};
const AchievementPreviewModal = () => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  const {
    trackId
  } = match.params;
  const {
    achievement
  } = useAchievementByTrackId(trackId);
  const trackName = achievement && getMetadataLanguageFallback(achievement.tracks[0].metadata, getLang()).name;
  useEffect(() => {
    UsageTracker.track('awardInteraction', {
      action: 'view-achievement-preview-modal',
      trackId: trackId.toString(),
      trackName,
      view: 'achievement-preview-modal'
    });
  }, [trackId, trackName]);
  const handleClose = useCallback(() => {
    UsageTracker.track('awardInteraction', {
      action: 'close-achievement-preview-modal',
      trackId: trackId.toString(),
      trackName,
      view: 'achievement-preview-modal'
    });
    // Preserve the location state when navigating back to award sharing
    history.push(getAwardSharingPath(trackId), location.state);
  }, [trackId, trackName, history, location]);
  if (!achievement) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "achievement-preview-modal",
    use: "conversational",
    width: 1250,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      color: "icon-core-subtle",
      "data-test-id": "achievement-close-preview",
      marginBlockStart: "50",
      onClick: handleClose
    }), /*#__PURE__*/_jsx(SingleCertAchievement, {
      inModal: true,
      language: getLang(),
      publicId: achievement.publicId,
      trackEvent: noop
    })]
  });
};
export default AchievementPreviewModal;